<template>
  <NuxtLayout
    id="app-main"
    class="h-full"
    :class="{
      'bg-gray-350': pwaInstalled && !isOnline
    }"
  >
    <section
      v-if="pwaInstalled && !isOnline"
      class="sm:py-28 sm:px-0 py-4 px-4 h-full relative text-center overflow-hidden flex items-center">
      <MoleculesDashboardOfflineFallback/>
    </section>

    <v2-organism-error-section
      v-else
      class="!py-10 md:!py-20 h-full relative overflow-hidden flex items-center"
      no-wrapper
    >
      <template #titleDesc>
        <strong>
          We can’t seem to find the page you’re looking for
        </strong>
      </template>

      <template #buttons>
        <v2-atoms-button
          size="large"
          theme="primary"
          :has-icon="false"
          @click="handleError"
        >
          Back to homepage
        </v2-atoms-button>
      </template>
    </v2-organism-error-section>
  </NuxtLayout>
</template>

<script setup>
defineOptions({
  name: 'ErrorPage'
})

const props = defineProps({
  error: {
    type: Object,
    default: () => ({})
  }
})

onMounted(async () => {
  await nextTick()

  // eslint-disable-next-line no-console
  console.error(props.error)
})

const { isOnline } = useOnlineStatus()
const pwaInstalled = usePwaInstalled()

const handleError = () => clearError({ redirect: '/' })
</script>
